
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_73_2657)"}},[_c('path',{attrs:{"d":"M0 0h30v20H0V0z","fill":"red"}}),_c('path',{attrs:{"d":"M13.1 3.8h3.8v4.4h4.4V12h-4.4v4.4h-3.8V12H8.8V8.1h4.4V3.8h-.1z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_73_2657"}},[_c('rect',{attrs:{"width":"30","height":"20","rx":"3","transform":"matrix(1 0 0 -1 0 20)","fill":"#fff"}})])])])
          )
        }
      }
    